import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import {
  SelectField,
  SelectFieldProps,
} from 'components/select-field/select-field';
import { pick } from 'utils/pick';

type FormItemSelectFieldProps = Omit<SelectFieldProps, 'value' | 'onChange'>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: {
      color: theme.palette.error.main,
      fontWeight: 'normal',
      height: '2em',
    },
  })
);

export function FormItemSelectField(props: FormItemSelectFieldProps) {
  const classes = useStyles();

  type TValue = string;

  const [field, meta, helpers] = useField<string>(props.name);

  const value: TValue = field.value || '';

  const handleChange = useCallback(
    (value: TValue) => {
      helpers.setValue(value);
    },
    [helpers]
  );

  const innerProps = pick(props, 'label', 'name', 'items', 'disabled');

  return (
    <>
      <div className={classes.error}>{meta.error}</div>
      <SelectField value={value} onChange={handleChange} {...innerProps} />
    </>
  );
}
